function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "New-Icon/Address",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Safespace",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "adres",
  transform: "translate(1.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#48A9A1",
  fillRule: "nonzero",
  opacity: 0.2,
  points: "16.68 18.59 1.32 18.59 1.32 8.2 9 15.23 16.68 8.2"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#48A9A1",
  fillRule: "nonzero",
  opacity: 0.2,
  points: "16.68 8.02 14.52 6.05 14.52 10.04"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#48A9A1",
  fillRule: "nonzero",
  opacity: 0.2,
  points: "9 0.99 5.39 4.29 12.61 4.29"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#48A9A1",
  fillRule: "nonzero",
  opacity: 0.2,
  points: "1.32 8.02 3.48 10.04 3.48 6.05"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#48A9A1",
  fillRule: "nonzero",
  opacity: 0.2,
  points: "3.48 10.04 9 15.23 3.48 10.04"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#48A9A1",
  fillRule: "nonzero",
  opacity: 0.2,
  points: "9 15.23 14.52 10.04 14.52 10.04"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#FFFFFF",
  points: "12.61 4.29 5.39 4.29 3.48 4.29 3.48 6.05 3.48 10.04 9 15.23 14.52 10.04 14.52 6.05 14.52 4.29"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "12.1 13 16.18 17.18 16.18 9.17 14.87 10.4"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "1.82 17.18 5.9 13 1.82 9.17"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "9 1.67 6.68 3.8 11.32 3.8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.18,8 C17.1727872,7.86296752 17.1072706,7.73557417 17,7.65 L15,5.82 L15,4.3 C15,4.02385763 14.7761424,3.8 14.5,3.8 L12.81,3.8 L9.34,0.62 C9.14473693,0.451261749 8.85526307,0.451261749 8.66,0.62 L5.19,3.8 L3.48,3.8 C3.20385763,3.8 2.98,4.02385763 2.98,4.3 L2.98,5.82 L1,7.65 C0.892729371,7.73557417 0.827212791,7.86296752 0.82,8 L0.82,18.58 C0.82,18.8561424 1.04385763,19.08 1.32,19.08 L16.68,19.08 C16.9561424,19.08 17.18,18.8561424 17.18,18.58 L17.18,8 Z M15,7.18 L15.92,8.02 L15,8.88 L15,7.18 Z M14.85,10.4 L16.16,9.17 L16.16,17.17 L12.1,13 L14.85,10.4 Z M15.65,18.08 L2.33,18.08 L6.63,13.68 L8.63,15.59 C8.7200649,15.6803782 8.84240729,15.7311785 8.97,15.7311785 C9.09759271,15.7311785 9.2199351,15.6803782 9.31,15.59 L11.31,13.68 L15.65,18.08 Z M9,1.67 L11.32,3.8 L6.68,3.8 L9,1.67 Z M4,4.8 L14,4.8 L14,9.8 L9,14.52 L4,9.82 L4,4.8 Z M5.9,13 L1.82,17.18 L1.82,9.18 L5.9,13 Z M3,7.18 L3,8.88 L2.06,8 L3,7.18 Z",
  id: "Shape",
  fill: "#555150",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.35,11.19 C6.92667592,10.9607871 6.57921291,10.6133241 6.35,10.19 C6.10719523,9.74249442 5.98648314,9.23895255 6,8.73 C5.98063682,8.16584404 6.11179374,7.6067014 6.38,7.11 C6.62807592,6.68028822 6.99657791,6.33264484 7.44,6.11 C7.9161764,5.86690723 8.44552971,5.74659966 8.98,5.76 C9.50055574,5.74491782 10.0174919,5.85104378 10.49,6.07 C10.901808,6.25508121 11.2497178,6.55776272 11.49,6.94 C11.7065967,7.33863901 11.8168072,7.78636926 11.81,8.24 C11.8243324,8.58069401 11.7699177,8.92078601 11.65,9.24 C11.5499581,9.49508673 11.3801528,9.71687317 11.16,9.88 C10.9439254,10.0331201 10.684803,10.1136582 10.42,10.11 C10.2158806,10.120447 10.0134614,10.0680972 9.84,9.96 C9.69724582,9.87161911 9.59354138,9.73215451 9.55,9.57 L9.55,9.57 C9.43679567,9.72543743 9.29818479,9.86066755 9.14,9.97 C8.97692429,10.0669451 8.7896359,10.1155014 8.6,10.11 C8.30051205,10.1239886 8.01054918,10.0028649 7.81,9.78 C7.61455726,9.52952434 7.51523248,9.21736074 7.53,8.9 C7.49582932,8.59629644 7.52999612,8.28879527 7.63,8 C7.73364779,7.75789299 7.9034835,7.54993089 8.12,7.4 C8.32928294,7.2484174 8.58159747,7.16781693 8.84,7.17 C8.99551959,7.16991849 9.14915207,7.20405904 9.29,7.27 C9.41875818,7.32812353 9.52187647,7.43124182 9.58,7.56 L9.58,7.56 L9.64,7.23 L10.48,7.23 L10.22,8.69 C10.2068699,8.80964083 10.2068699,8.93035917 10.22,9.05 C10.2119579,9.14848744 10.236557,9.24688382 10.29,9.33 C10.3466148,9.39682337 10.4330683,9.43065299 10.52,9.42 C10.6033606,9.41008408 10.6791355,9.36678409 10.73,9.3 C10.816253,9.18752165 10.8776092,9.05799202 10.91,8.92 C10.9728183,8.69206995 11.0031178,8.45640756 11,8.22 C11.0305362,7.71980876 10.8361857,7.23209903 10.47,6.89 C10.044871,6.55495249 9.50987182,6.39088607 8.97,6.43 C8.58417871,6.42341455 8.202762,6.5127554 7.86,6.69 C7.53343689,6.87149958 7.26872723,7.14665831 7.1,7.48 C6.90007131,7.86615803 6.79710955,8.29516538 6.8,8.73 C6.7890791,9.11829682 6.87499594,9.50320429 7.05,9.85 C7.21806231,10.1610299 7.47128537,10.4177217 7.78,10.59 C8.13275421,10.7693244 8.52437633,10.8586417 8.92,10.85 C9.18363918,10.8578557 9.44686904,10.8241083 9.7,10.75 C9.88324009,10.7038897 10.0496666,10.6068075 10.18,10.47 L11.25,10.47 C11.055025,10.8159994 10.7533335,11.0896266 10.39,11.25 C9.9299876,11.462926 9.42665975,11.565646 8.92,11.55 C8.37474956,11.5636412 7.83483457,11.4398391 7.35,11.19 Z M9.26,9.08 C9.39140977,8.85966308 9.45731619,8.60644367 9.45,8.35 C9.46072782,8.20333661 9.41811257,8.0577345 9.33,7.94 C9.24643875,7.84637712 9.12539123,7.79502363 9,7.8 C8.78065868,7.80171178 8.58037291,7.92496456 8.48,8.12 C8.3585559,8.34032118 8.29652399,8.5884488 8.3,8.84 C8.29362743,8.98023075 8.3283862,9.11926584 8.4,9.24 C8.46666308,9.33927806 8.5805797,9.39623637 8.7,9.39 C8.92916602,9.39625285 9.14364018,9.27752609 9.26,9.08 Z",
  id: "Shape",
  fill: "#48A9A1",
  fillRule: "nonzero"
})));

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Email.1e4f293d.svg";
export { ForwardRef as ReactComponent };